// Google's sign-in widget takes a fixed pixel width (200-400) and can't stretch with CSS, so it's
// given the width of the form it sits under, to line up with the "Sign in" button (owner,
// 2026-10-04). Before the first measurement it keeps the old 300px.
const MIN = 200;
const MAX = 400;
const FALLBACK = 300;

export function googleButtonWidth(containerWidth) {
  if (!containerWidth) return FALLBACK;
  return Math.min(MAX, Math.max(MIN, Math.floor(containerWidth)));
}
